module.exports = __webpack_public_path__ + "media/images/icons/country_flags/ee-04263f937da9572d0d8435925c4de87b.svg";